import { render } from "./GameIntroduction.vue?vue&type=template&id=359d6fac"
import script from "./GameIntroduction.vue?vue&type=script&lang=js"
export * from "./GameIntroduction.vue?vue&type=script&lang=js"

import "./GameIntroduction.vue?vue&type=style&index=0&id=359d6fac&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__